import { Component, Input } from '@angular/core';
import { HeaderComponent } from '../header/header.component';

@Component({
  selector: 'app-mobile-menu',
  templateUrl: './mobile-menu.component.html',
  styleUrls: ['./mobile-menu.component.less'],
})
export class MobileMenuComponent extends HeaderComponent {
  @Input() nzClass = '';

  ngOnInt(): void {
    if(!this.nzClass) {
      this.nzClass = ''
    }
  }

  getMobileCategoryKey(index: number): string {
  switch (index) {
    case 1:
      return 'products';
    case 2:
      return 'our-advisers';
    case 4:
      return 'about-igm';
    default:
      return 'insights';
  }
}
}
